A job requisition or position opening within an organization.

This is a container object that groups multiple `PositionProfile`s together along with their owner.
